import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { RoutePermissions, TypedRoute } from '../app-routing.module';
import { User } from '../models/user';
import { UserLogin } from '../models/userlogin';
import { LoginService } from '../services/login.service';
import { NotificationService } from '../services/notification.service';

// export interface RoutePermissions {
//   RouteAccessLevel: 'Admin';
// }

export interface TypedRouteSnapshot extends ActivatedRouteSnapshot {
  data: RoutePermissions;
}

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  User!: UserLogin | null;
  NotAuthorizedMsg = {
    Type: "danger",
    Message: "Unauthorized acccess!",
    Body: `You don't have requred permissions for this route.`
  }
  constructor(private router: Router, private notificationService: NotificationService, private loginService: LoginService) {
    this.loginService.User.subscribe(x => {
      if (x) this.User = x
    });
  }

  canActivate(
    route: TypedRouteSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (!this.User) {
      this.router.navigate(['/login']);
      return false;
    }

    const userRole = this.User.Role;

    if (userRole == 'Admin') return true;
    
    if (route.data.Permissions) {
			for (let i: number = 0; i < route.data.Permissions?.length; i++) {
				if (userRole == route.data.Permissions[i]) return true;
			}
		}

    // Not authorized
    this.notificationService.Notifications.next(this.NotAuthorizedMsg);

    this.router.navigate(['']);
    return false;
  }
}
